export default {
  modalTitle: 'Are you sure you want to quit?',
  modalMessage: 'If you quit now, you be unable to sign into My Client Space.',
  exit: 'Quit',
  notNow: 'Cancel',
};
